import gql from 'graphql-tag';

export const ReadTimeSmartsQuery = gql`
	query ReadTimeSmartsQuery($id: ID!) {
		getSmartContentFeature(contentId: $id) {
			readTime
		}
	}
`;
